<template>
    <div v-if="this.status === 'idpay_pending'" class="os-header--idPayConfirmation">
        <div class="os-header__idPayConfirmation">
            <img v-if="idPayRedirect" class="os-header__image" src="@/assets/img/id-pay-redirect.svg" alt="" tabindex="-1" />
            <img v-else class="os-header__image" src="@/assets/img/id-pay-confirmation.svg" alt="" tabindex="-1" />
            <h1 class="os-header__title">
                <span v-text="$ml.get(idPayRedirect ? 'confirmationInProgress' : 'identityConfirmation')" />
            </h1>
            <p class="os-header__texts">
                <span v-text="$ml.get(idPayRedirect ? 'idPayRedirectText' : 'idPayConfirmation')" />
            </p>
        </div>
    </div>
    <div v-else class="os-header">
        <img
            class="os-header__img"
            :class="this.selectedOrderStatusConfig.biggerIcon ? 'os-header__img--bigger' : ''"
            :src="this.selectedOrderStatusConfig.icon"
            alt=""
            tabindex="-1"
        />

        <h1 class="os-header__title" v-text="$ml.get(this.selectedOrderStatusConfig.title)" tabindex="0" />

        <p class="os-header__texts" tabindex="0">
            <span
                v-for="(item, index) in this.selectedOrderStatusConfig.texts"
                :key="index"
                v-text="item.hasMerchantName ? $ml.with(0, merchantName).get(item.text) : $ml.get(item.text)"
                class="os-header__text"
            />
        </p>
    </div>
</template>

<script>
    import OrderStatusHeaderConfig from '@/models/OrderStatusHeaderConfig';

    export default {
        data() {
          return {
              selectedOrderStatusConfig: {},
          };
        },

        props: {
            status: {
                type: String,
                required: true,
            },
            merchantName: {
                type: String,
                default: '',
            },
            idPayRedirect: {
                type: String,
                default: '',
            },
        },

        methods: {
            setStatusConfig() {
                this.selectedOrderStatusConfig = OrderStatusHeaderConfig[this.status];
            },
        },

        computed: {
        },

        created() {
            this.setStatusConfig();
        },
    };
</script>

<style lang="scss" scoped>
    .os-header {

        &__img {
            width: 56px;
            height: 56px;
            margin-bottom: 24px;
        }

        &__img--bigger {
            width: 100%;
            max-width: 200px;
            height: auto;
        }

        &__title {
            font-weight: 700;
            font-size: 20px;
            line-height: 14px;
            margin-bottom: 20px;
            color: #2F363E;
        }

        &__texts {
            font-size: 16px;
            line-height: 24px;
            color: #5C6A7B;
            margin-bottom: 24px;
        }

        &__text {
            &:first-of-type {
                display: block;
            }
        }

        &__link {
            color: #0774E7;
            font-weight: 700;
        }

		&--idPayConfirmation {
			width: 100%;
			max-width: 600px;

			@media screen and (max-width: 1024px) {
                display: flex;
                flex-direction: column;
                flex: 1 0 auto;
            }

			&__image {
                width: 100%;
                max-width: 200px;
                height: auto;
            }
		}
    }

</style>
